"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (sec) {
    var minute = Math.floor(sec / 60);
    var hour = Math.floor(minute / 60);
    var day = Math.floor(hour / 24);

    return [sec, minute, hour, day];
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/splitSecsToUnits.js
// module id = 19
// module chunks = 0